export default "__VITE_ASSET__D0Z7zT7H__"